import {ServiceLocator} from '../app/ServiceLocator';
import {SolrErrorCode} from '../ts/helpers/ErrorCodes';
import {AuthLevel, getSessionManagementServiceInstance} from '../sessionManagement/SessionManagementService';
import {LoginUrlsWrapper} from '../app/spaces/Login/LoginUrls';
import {ServerUrls} from '../app/ServerUrls';
import {getAppStore} from '../app/AppStore';
import {showRouterError} from '../app/actions/spaces/RouterErrorActions';

export function maybeHandleSearchServerDown(errorCode: number) {
    //TODO remote reference to angular's $location
    const $location: ng.ILocationService = ServiceLocator.get<ng.ILocationService>('$location');
    if (errorCode && errorCode === SolrErrorCode.SolrCommunicationError || errorCode === SolrErrorCode.SolrDisabled) {
        if (!getSessionManagementServiceInstance().isUserAuthorized(AuthLevel.ServerAdmin)) {
            LoginUrlsWrapper.navigateToSignInErrorCode('' + errorCode);
        } else if ($location.path() !== ServerUrls.getInstance().statusPath()) {
            getAppStore().dispatch(showRouterError('search-server-down'));
        }
        return true;
    } else {
        return false;
    }
}